import DeleteIcon from '@mui/icons-material/Delete';
import { Button, IconButton } from '@mui/material';
import * as React from 'react';

const ButtonFile = ({
  id,
  text,
  src,
  name,
  file,
  sxc,
  st,
  onFile,
  onDelete,
  size,
  isFile,
  isAvatar = true,
}) => {
  return (
    <div style={sxc}>
      <label htmlFor={id}>
        <input
          id={id}
          name={id}
          style={{ display: 'none' }}
          type="file"
          accept={isAvatar ? 'image/png, image/jpg, image/jpeg' : '*'}
          onChange={(e) => onFile(e.target.files[0])}
        />
        <Button className="btn-choose" variant="outlined" component="span">
          {text}
        </Button>
      </label>
      <div
        className="file-name"
        sx={{
          width: size ?? '80%',
        }}
      >
        {file && (
          <IconButton aria-label="delete" onClick={onDelete} color="error">
            <DeleteIcon />
          </IconButton>
        )}
        {name ?? (file ? file.name : null)}
      </div>
      {isFile ? null : (
        <img
          style={{
            width: size ?? '80%',
            ...st,
          }}
          src={src || (file ? URL.createObjectURL(file) : null)}
          alt={file ? file.name : src ? src.name : ''}
        />
      )}
    </div>
  );
};

export default ButtonFile;
